import { memo, useEffect, useRef } from "react";
import { cn } from "utils";
import { recommendationMap } from "../constants";
import { drawGauge, GaugeOptions } from "@components/createChart";
import { useD3Ready } from "@hooks/useD3Ready";

interface ChartRatingProps {
  verdict?: string;
}

const ChartRating = ({ verdict = "Strong Sell" }: ChartRatingProps) => {
  // 确保进度值在0-100范围内
  const ref = useRef<HTMLDivElement>(null);
  const d3Ready = useD3Ready();

  useEffect(() => {
    if (!d3Ready || !ref.current) {
      return;
    }
    const gaugeOptions: GaugeOptions = {
      el: ref.current,
      value: verdict,
      segments: [
        {
          name: recommendationMap.STRONG_SELL,
          color: "rgba(255, 115, 117, 1)",
          activeLabelColor: "#FF7375",
        },
        {
          name: recommendationMap.SELL,
          color: "rgba(255, 188, 148, 1)",
          activeLabelColor: "#FD8016",
        },
        {
          name: recommendationMap.NEUTRAL,
          color: "rgba(255, 255, 176, 1)",
          activeLabelColor: "#FFFFB0",
        },
        {
          name: recommendationMap.BUY,
          color: "rgba(0, 150, 108, 1)",
          activeLabelColor: "#02D79B",
        },
        {
          name: recommendationMap.STRONG_BUY,
          color: "rgba(2, 215, 155, 1)",
          activeLabelColor: "#00966C",
        },
      ],
    };

    drawGauge(gaugeOptions);
  }, [d3Ready, verdict]);

  return (
    <div className="relative w-full max-w-[305px]">
      {/* 半圆弧 - 使用 SVG 渐变 */}
      <div className="w-full h-[129px]" ref={ref}></div>

      {/* 中心评级徽标 */}
      <div
        className={cn(
          "absolute bottom-4 left-1/2 -translate-x-1/2 w-fit py-0.5 px-3 inline-flex items-center rounded-1.5 body_bold_l",
          {
            "bg-background_accent2_overlay20 text-content_accent2_primary":
              verdict === recommendationMap.STRONG_SELL,
            "bg-background_accent3_overlay20 text-content_accent3_primary":
              verdict === recommendationMap.SELL,
            "bg-[#FFFFB0]/20 text-[#FFFFB0]":
              verdict === recommendationMap.NEUTRAL,
            "bg-background_accent1_overlay20 text-content_accent1_primary":
              verdict === recommendationMap.BUY,
            "bg-[rgba(0,150,108,0.20)] text-content_accent1_primary":
              verdict === recommendationMap.STRONG_BUY,
          },
        )}
      >
        {verdict}
      </div>
    </div>
  );
};

export default memo(ChartRating);
